import { Licensing } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface LicensingResponse extends DefaultResponse<Licensing> {}

interface GetLicensingParamsType {
  status?: number;
  filters?: Record<string, unknown>;
}

export const licensingService = {
  async findAll({ status = 1, filters = {} }: GetLicensingParamsType = {}) {
    const response = await api.get<DefaultResponse<Licensing, true>>(
      "vehicle_licensing",
      {
        params: {
          "eq[status]": status,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<LicensingResponse>("/vehicle_licensing", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<Licensing, false>>(
      `/vehicle_licensing/${id}`,
    );
    return response.data;
  },

  async store(data: Partial<Licensing>) {
    const response = await api.post<DefaultResponse<Licensing, false>>(
      "/vehicle_licensing",
      data,
    );
    return response.data;
  },

  async update(id: number | string, data: Partial<Licensing>) {
    const response = await api.put<DefaultResponse<Licensing, false>>(
      `/vehicle_licensing/${id}`,
      data,
    );
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete<DefaultResponse<never>>(
      `/vehicle_licensing/${id}`,
    );
    return response.data;
  },

  async setPaymentDate(id: number, payment_date: string) {
    const response = await api.put<DefaultResponse<Licensing, false>>(
      `/vehicle_licensing/${id}/pay`,
      { payment_date },
    );
    return response.data;
  },
};
